import {useCallback, useEffect, useRef, useState} from 'react';
import {Box, Button, Divider, Grid, IconButton, makeStyles, Menu, MenuItem} from "@material-ui/core";
import AgendaItem from "./agendaItem";
import clsx from 'clsx';
import ImmersionModal from "../../../../../atoms/modals/commonModal";
import AddAgenda from './addAgenda';
import {removeMarker, updateMarker} from '../../../../../../store/actions/creator/analysis';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchSessionMarker,
  getSessionParticipants
} from '../../../../../../store/actions/creator/creatorExperienceManager';
import UtilService from "../../../../../../helper/service";

//import {useStylesTooltip} from "../../../../../../config/theme";
import {BackDropAnalyzeLoading} from "../../../../../atoms/commonLoadings";
import {apiClient} from "../../../../../../config/apiClient";


const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 0,
    '@media screen and (max-width: 600px)': {
      paddingTop: 0
    }
  },
  sectionTitle: {
    fontSize: 24,
    fontFamily: 'Spartan-bold',
    color: '#697683',
    padding: '25px 0',
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  cardSection: {
    borderRadius: 20,
    marginTop: 40,
    background: '#fff',
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)"
  },
  pdfCardSection: {
    borderRadius: 20,
    marginTop: 40,
    background: '#fff',
    border: '1px solid rgba(0, 0, 0, 0.1)',
  },
  content: {
    padding: '20px 50px!important',
    '@media screen and (min-width: 367px) and (max-width: 600px)': {
      padding: '20px 20px!important'
    },
    '@media screen and (max-width: 366px)': {
      padding: '20px 10px!important'
    }
  },
  description: {
    fontSize: 16,
    fontFamily: 'roboto-medium',
    color: '#697683'
  },
  fillBtn: {
    fontFamily: 'roboto-regular',
    backgroundColor: '#0179EE',
    borderRadius: 6,
    fontSize: 16,
    boxShadow: 'none',
    textTransform: 'none',
    display: 'flex',
    marginTop: 30,
    alignItems: 'center'
  },
  editAgendaBtn: {
    position: 'absolute',
    right: 60,
    marginTop: 0
  },
  fillOutIcon: {
    width: 24,
    height: 24
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  menuItem: {
    padding: 0
  },
  sortBtn: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    textTransform: 'unset',
    marginRight: 20,
    marginLeft: 20,
    width: '100%'
  },
  sortText: {
    fontSize: 14,
    fontFamily: 'roboto-bold',
    color: '#017AEF'
  },
  sortIcon: {
    width: 7,
    height: 10
  },
  headerPanel: {
    cursor: 'pointer'
  },
  itemSection: {
    paddingTop: 20
  },
  typeDescription: {
    fontSize: 16,
    fontFamily: 'roboto-medium',
    color: '#697683',
    marginTop: 40
  },
  bold: {
    fontFamily: 'roboto-black'
  },
  titleBox: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center'
  },
  title: {
    color: '#212D40',
    fontSize: 22,
    fontFamily: 'roboto-bold'
  },
  tr: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    backgroundColor: '#fff'
  },
  td: {
    border: '1px solid #707070',
    height: 34,
    padding: 5,
    display: 'flex',
    flex: 1,
    fontFamily: 'roboto-regular',
    alignItems: 'center',
    color: '#717E8B',
    overflow: 'hidden',
    width: '100%'
  },
  hover: {
    backgroundColor: '#EEF4FD',
    color: '#212D40',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  doneBtn: {
    margin: 0,
    padding: 0,
    height: 22,
    background: '#697683',
    borderRadius: 4,
    color: '#fff',
    fontSize: 9,
    marginTop: -13,
    marginLeft: 5,
    '&:hover': {
      background: '#343B43'
    }
  },
  textField: {
    "& .MuiOutlinedInput-inputMarginDense": {
      margin: "0!important",
      border: '1px solid #697683',
      padding: 2,
      borderRadius: 3,
      paddingLeft: 6
    }
  },
  icons: {
    position: 'absolute',
    right: -160,
    marginTop: 5
  },
  icon: {
    marginLeft: 5,
    '&:hover': {
      background: '#e0e0e0',
      borderRadius: 5
    }
  },
  hidden: {
    display: 'none'
  },
  ml: {
    right: -80
  },
  agenda: {
    color: '#212D40',
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'left',
    marginTop: 10,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  addAgendaHover: {
    '&:hover': {
      color: '#0f9fef'
    }
  },
  agendaTable: {
    border: '17px solid #FFE9C4',
    borderRadius: 17,
    width: '100%'
  },
  label: {
    "&$focusedLabel": {
      color: "#707070"
    },
    "&$erroredLabel": {
      color: "#707070"
    }
  },
  focusedLabel: {
    fontSize: 14,
    fontFamily: 'roboto-black',
  },
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#8F99A3',
    "&$error:after": {
      borderBottomColor: "#017AEF"
    },
    "&:after": {
      borderBottom: `1px solid #017AEF`
    }
  },
  error: {},
  calendarBtnLabel: {
    fontSize: 16,
    fontFamily: 'roboto-regular',
    textTransform: 'none'
  },
  agendaItem: {
    padding: 8,
    '@media screen and (max-width: 366px)': {
      padding: 3
    }
  },
  popover: {
    background: '#fff',
    width: 230,
    boxShadow: '0px 0px 10px #00000033',
    borderRadius: 10,
    marginTop: "-140px",
    position: 'absolute',
    marginLeft: 10,
    zIndex: 2
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '0 0 -2px 12px'
  },
  modalTitle: {
    fontFamily: 'roboto-bold',
    color: '#606B76',
    fontSize: 14,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  modalCloseIcon: {
    width: 10,
    height: 10,
    background: 'transparent'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    color: '#1DB859',
    fontSize: 12,
    margin: 0
  },
  name_index: {
    margin: '0 7px',
    fontSize: 18
  },
  label_index: {
    fontFamily: 'Spartan-bold',
    letterSpacing: 1.2,
    paddingTop: 4,
    textTransform: 'uppercase'
  },
  popperBadgeIcon: {
    width: 20,
    height: 20
  },
  pane: {
    display: 'flex',
    flexDirection: 'row',
    color: '#8191A1',
    marginTop: 6
  },
  smallRow: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    color: '#8191A1',
  },
  timeLabel: {
    fontFamily: 'Spartan-extrabold',
    fontSize: 10,
    marginRight: 3
  },
  segmentWord: {
    fontFamily: 'Spartan-bold',
    fontSize: 8,
    textTransform: 'uppercase',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  clock: {
    width: 12,
    height: 12,
    marginRight: 3
  },
  pencil: {
    width: 12,
    height: 12,
    marginRight: 5,
    marginLeft: 8,
  },
  editIconDiv: {
    border: '1px solid #717e8b',
    borderRadius: 6,
    cursor: 'pointer',
    padding: '0px 3px 0px 0px',
    backgroundColor: '#F0F0F0',
    position: 'absolute',
    right: 0,
    marginTop: 0,
    '&:hover': {
      opacity: 0.7
    }
  },
  pencilIcon: {
    marginLeft: 4,
    width: 32
  },
}));

interface IProps {
  agendaImmersions: any[];
  agendaSafes: any[];
  overviewAgendas: any[];
  isMobile: boolean;
}

const Agenda = (props: IProps) => {
  const classes = useStyles();
  //const tooltipClasses = useStylesTooltip();
  const { agendaImmersions, agendaSafes, overviewAgendas, isMobile } = props;
  const { sessionData, identifiers } = useSelector((state: any) => state.creatorExperienceManager);
  const { cliped } = useSelector((state: any) => state.analysis);
  const [agendaImmersionList, setAgendaImmersionList] = useState<any[]>([]);
  const [agendaSafeList, setAgendaSafeList] = useState<any[]>([]);
  const [overviewAgendaList, setOverviewAgendaList] = useState<any[]>([]);

  const [showAgendaModal, setShowAgendaModal] = useState(false);
  const immersionAnchorRef = useRef(null);
  const [immersionMenu, setImmersionMenu] = useState(false);
  const [immersionSortIndex, setImmersionSortIndex] = useState(0);
  const [immersionSortText, setImmersionSortText] = useState('Sort Chronologically');
  const [agendaByImmersion, setAgendaByImmersion] = useState<any[]>([]);
  const safeAnchorRef = useRef(null);
  const [safeMenu, setSafeMenu] = useState(false);
  const [safeSortIndex, setSafeSortIndex] = useState(0);
  const [safeSortText, setSafeSortText] = useState('Sort Chronologically');
  const [agendaBySafe, setAgendaBySafe] = useState<any[]>([]);
  const [agendas, setAgendas] = useState([]);
  const [removeIds, setRemoveIds] = useState<any[]>([]);
  const [isLoadingAgenda, setIsLoadingAgenda] = useState(false);
  const [openImmersion, setOpenImmersion] = useState(false);
  const [openSafety, setOpenSafety] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  // const [oldRemoveIds, setOldRemoveIds] = useState<any[]>([]);
  const [allClipLoading, setAllClipLoading] = useState(false);

  const currentSessionCode: any = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
  const dispatch = useDispatch();
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
  const { analyseStart, analyseEnd, stimulus, settings } = useSelector((state: any) => state.analysis);
  const { pdfLoading } = settings;

  useEffect(() => {
    if (cliped) {
      if (agendaImmersions.length > 0) {
        setAgendaImmersionList([
          ...agendaImmersions.filter((immersionAgenda: any) =>
            (cliped['start_clip'] <= immersionAgenda['start'] && immersionAgenda['start'] < cliped['end_clip'])
            || (cliped['start_clip'] < immersionAgenda['end'] && immersionAgenda['end'] <= cliped['end_clip'])
            || (immersionAgenda['start'] < cliped['start_clip'] && cliped['end_clip'] < immersionAgenda['end'])
          )
        ])
      }
      if (agendaSafes.length > 0) {
        setAgendaSafeList([
          ...agendaSafes.filter((safeAgenda: any) =>
            (cliped['start_clip'] <= safeAgenda['start'] && safeAgenda['start'] < cliped['end_clip'])
            || (cliped['start_clip'] < safeAgenda['end'] && safeAgenda['end'] <= cliped['end_clip'])
            || (safeAgenda['start'] < cliped['start_clip'] && cliped['end_clip'] < safeAgenda['end'])
          )
        ])
      }
      if (overviewAgendas.length > 0) {
        setOverviewAgendaList([
          ...overviewAgendas.filter((overviewAgenda: any) =>
            (cliped['start_clip'] <= Number(overviewAgenda['start_marker_at']) && Number(overviewAgenda['start_marker_at']) < cliped['end_clip'])
            || (cliped['start_clip'] < Number(overviewAgenda['end_marker_at']) && Number(overviewAgenda['end_marker_at']) <= cliped['end_clip'])
            || (Number(overviewAgenda['start_marker_at']) < cliped['start_clip'] && cliped['end_clip'] < Number(overviewAgenda['end_marker_at']))
          )
        ])
      }
    } else {
      setAgendaImmersionList([...agendaImmersions]);
      setAgendaSafeList([...agendaSafes]);
      setOverviewAgendaList([...overviewAgendas]);
    }
  }, [cliped, agendaImmersions, agendaSafes, overviewAgendas]);

  const handleImmersionMenuOpen = () => {
    setImmersionMenu(true);
  };

  const handleImmersionMenuClose = () => {
    setImmersionMenu(false);
  };

  const onImmersionSort = (sortIndex: number) => {
    if (sortIndex) { // Sort by Immersion
      const bufList: any[] = [...overviewAgendaList];
      bufList.sort((a, b) => getImmersion(b)['overall_index'] - getImmersion(a)['overall_index']);
      setAgendaByImmersion(bufList);
    }
    setImmersionSortIndex(sortIndex);
    handleImmersionMenuClose();
  };

  const handleSafeMenuOpen = () => {
    setSafeMenu(true);
  };

  const handleSafeMenuClose = () => {
    setSafeMenu(false);
  };

  const onSafeSort = (sortIndex: number) => {
    if (sortIndex) { // Sort by Safe
      const bufList: any[] = [...overviewAgendaList];
      bufList.sort((a, b) => getSafety(b)['overall_index'] - getSafety(a)['overall_index']);

      setAgendaBySafe(bufList);
    }
    setSafeSortIndex(sortIndex);
    handleSafeMenuClose();
  };

  const handleOpenAgendaModal = () => {
    setShowAgendaModal(true);
  };

  const updateAgenda = async (position: any, index: number) => {
    const request: any = {
      session_code: currentSessionCode,
      marker_title: position.title,
      marker_start_at: UtilService.getAgendaDateTimestamp(Number(analyseStart), Number(analyseEnd), stimulus, agendas.length, index, true),
      marker_end_at: UtilService.getAgendaDateTimestamp(Number(analyseStart), Number(analyseEnd), stimulus, agendas.length, index, false),
      marker_type: 1,
      marker_id: position.marker_id ? parseFloat(position.marker_id) : null,
      user_id: parseFloat(loginUserData.user_id),
    };

    dispatch(await updateMarker(apolloClient.client, request, () => { }))
  };

  const onSaveComments = async () => {
    setIsLoadingAgenda(true);
    if (!agendas || agendas.length < 1 || !analyseStart || !analyseEnd) {
      setShowAgendaModal(false);
      setIsLoadingAgenda(false);
      return;
    }
    await Promise.all([removeIds.map((id: any) => {
      id && dispatch(removeMarker(apolloClient.client, { marker_id: parseInt(id) }))
    }
    )]);
    await Promise.all([agendas.map((position: any, index: number) => {
      updateAgenda(position, index)
    })]);

    setTimeout(() => {
      dispatch(fetchSessionMarker(apolloClient.client, { session_code: currentSessionCode }, null))
      setIsLoadingAgenda(false);
      setShowAgendaModal(false);
    }, 2000);
    setTimeout(() => {
      dispatch(fetchSessionMarker(apolloClient.client, { session_code: currentSessionCode }, null))
    }, 5000);
    setTimeout(() => {
      dispatch(fetchSessionMarker(apolloClient.client, { session_code: currentSessionCode }, null))
    }, 10000);
  };

  const onChange = (updatedAgenda: any, removeId?: any) => {
    setAgendas(updatedAgenda);
    if (!removeId) return;

    const newArray = [...removeIds];
    if (!removeIds.includes(removeId)) {
      newArray.push(removeId);
    } else {
      newArray.splice(
        newArray.findIndex((item: any) => item === removeId),
        1
      );
    }
    setRemoveIds(newArray);
  };

  const onRemoveIds = (ids: any) => {
    setRemoveIds([...ids, ...removeIds]);
  };

  const getImmersion = useCallback((item: any) => {
    let immersion = agendaImmersionList.length > 0 && agendaImmersionList.find((immersion: any) => (immersion.start === Number(item.start_marker_at) && immersion.end === Number(item.end_marker_at)));

    if (!immersion) {
      immersion = {
        color_indicator: "Red",
        context_indicator: "No Data",
        end: Number(item.end_marker_at),
        overall_index: 0,
        start: Number(item.start_marker_at),
        tier_indicator: "Blank"
      }
    }
    return immersion;
  }, [agendaImmersionList]);

  const getSafety = useCallback((item: any) => {
    let safety = agendaSafeList.length > 0 && agendaSafeList.find((safe: any) => (safe.start === Number(item.start_marker_at) && safe.end === Number(item.end_marker_at)));

    if (!safety) {
      safety = {
        color_indicator: "Gray",
        context_indicator: "",
        end: Number(item.end_marker_at),
        overall_index: 0,
        start: Number(item.start_marker_at),
        tier_indicator: ""
      }
    }

    return safety;
  }, [agendaSafeList]);

  const openPopover = (type: string, item: any) => {
    if (type === 'immersion') {
      setOpenImmersion(true);
      setOpenSafety(false);
    } else {
      setOpenSafety(true);
      setOpenImmersion(false);
    }
    setSelectedItem(item);
  };

  const closePopover = () => {
    setSelectedItem(null);
    setOpenImmersion(false);
    setOpenSafety(false);
  };

  const getImmersionBadgeIcon = (item: any) => {
    const immersion = getImmersion(item);
    return `/assets/icons/liveanalysis/icon_immersion_${immersion['color_indicator'].toLowerCase()}.svg`;
  };

  const getSafetyBadgeIcon = (item: any) => {
    const safety = getSafety(item);
    return (safety['overall_index'] === 1 || safety['overall_index'] === 0)
      ? `/assets/icons/liveanalysis/icon_safety_gray.svg`
      : `/assets/icons/liveanalysis/icon_safety_${safety['color_indicator'].toLowerCase()}.svg`;
  };

  const getColor = (color: string) => {
    switch (color.toLowerCase()) {
      case 'green':
        return '#1CB858';
      case 'gray':
        return '#8191A1';
      case 'red':
        return '#ED554A';
      default:
        return '#8191A1';
    }
  };

  const getImmersionOverallIndex = (immersion: any) => {
    return immersion['overall_index'] !== 0 ? immersion['overall_index'] : '--';
  };

  const getSafetyOverallIndex = (safety: any) => {
    return safety['overall_index'] !== 0 ? safety['overall_index'] : '--';
  };

  const getImmersionContextIndex = (immersion: any) => {
    return immersion['context_indicator'];
  };

  const getSafetyContextIndex = (safety: any) => {
    return safety['context_indicator'];
  };

  const getRuntime = (epoch_start: number, epoch_end: number) => {
    return UtilService.overviewHighlightsTimeFormat(epoch_end - epoch_start);
  };

  const getSegment = (timeStr: string, type: string, noteId: number) => {
    return (
      <div className={classes.pane}>
        <div className={classes.smallRow}>
          <img src={'/assets/icons/participant/clock-deactive.svg'} alt={'icon'} className={classes.clock} />
          <span className={classes.timeLabel} >{timeStr}</span>
          <span className={classes.segmentWord}>{type}</span>
        </div>
        {noteId >= 0 && agendas && agendas.length > noteId && agendas && (
          <div className={classes.smallRow}>
            <img src={'/assets/icons/liveanalysis/grey-pencil.svg'} alt={'icon'} className={classes.pencil} />
            <span className={classes.segmentWord} >{agendas[noteId]['marker_title']}</span>
          </div>
        )}
      </div>
    )
  };

  const getEpochTime = (epoch_time: number) => {
    if (analyseStart) {
      if (sessionData['session']['session_status'] === 'COMPLETED' && identifiers.length > 0) {
        return UtilService.secondsToHms(Number(epoch_time) - analyseStart);
      } else {
        return UtilService.secondsToHms(Number(epoch_time) - analyseStart);
      }
    } else {
      return UtilService.secondsToHms(0);
    }
  };

  const showSafety = useCallback(() => {
    const length = cliped ? Number(cliped.end_clip - cliped.start_clip) : Number(sessionData['session']['session_length']);
    if (UtilService.isShowSafety('MODERATED', length)) {
      if (overviewAgendaList.length > 0) { // don't show safe agenda section if all items has no safety score
        for (const item of overviewAgendaList) {
          if (getSafety(item).overall_index !== 0) {
            return true;
          }
        }
      }
      return false;
    } else {
      return false;
    }
  }, [sessionData, cliped, overviewAgendaList]);

  const onClipAll = useCallback(async () => {
    setAllClipLoading(true);
    const tenant_id = loginUserData.customer_id;
    for (const item of overviewAgendaList) {
      const clipName = item.marker_title;

      const request = {
        stimulus_id: currentSessionCode,
        type: 'clip-moderated',
        session_code: currentSessionCode,
        clip: {
          title: clipName,
          start_clip: String(item.start_marker_at),
          end_clip: String(item.end_marker_at)
        }
      };

      await apiClient(true).post(`/stimulus/v2/stimulus/clips/${tenant_id}/${currentSessionCode}`, { ...request });
    }

    // not show loading bar after 2 seconds
    setTimeout(() => {
      fetchClips();
      setAllClipLoading(false);
    }, 25000)
  }, [overviewAgendaList, currentSessionCode]);

  const fetchClips = () => {
    const request = {
      session_code: currentSessionCode,
    };
    dispatch(getSessionParticipants(apolloClient.client, request, ()=>{}));
  };

  return (
    <div className={classes.root} id='agenda'>
      <BackDropAnalyzeLoading loading={allClipLoading} />
      <div className={classes.sectionTitle}>
        {/*<Tooltip classes={tooltipClasses} title="To edit start and end times of agenda items, go to Analyze Tab" placement="bottom" arrow>
          <span>Agenda</span>
        </Tooltip>*/}
        {!isMobile && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button className={clsx(classes.fillBtn, classes.editAgendaBtn)} variant="contained" color="primary" onClick={onClipAll}>
              <img className={classes.fillOutIcon} src={`/assets/icons/overview/scissors-icon.svg`} alt='Clip All' />&nbsp;
              Clip All
            </Button>
            <div className={classes.editIconDiv} style={{ marginRight: 10 }}>
              <img
                src={'/assets/icons/experiencebuilder/edit-icon.svg'}
                alt="Edit Agenda"
                title="Edit Agenda"
                className={classes.pencilIcon}
                onClick={() => handleOpenAgendaModal()}
              />
            </div>
          </div>
        )}
      </div>

      {overviewAgendaList && overviewAgendaList.length > 0 &&
        <>
          <div data-description='immersion section'>
            <p className={classes.typeDescription} style={{ marginTop: 15 }}>How <span className={classes.bold}>Immersed</span> were your participants during agenda sections?</p>
            <div className={pdfLoading ? classes.pdfCardSection : classes.cardSection}>
              <div className={classes.content}>
                <div className={classes.cardHeader}>
                  <div className={classes.headerPanel} onClick={handleImmersionMenuOpen} ref={immersionAnchorRef}>
                    <span className={classes.sortText}>{immersionSortText}</span> &nbsp;
                    <img className={classes.sortIcon} src={`/assets/icons/overview/sort-icon.svg`} alt='Sort' />
                  </div>
                  <Menu
                    anchorEl={immersionAnchorRef.current}
                    elevation={1}
                    onClose={handleImmersionMenuClose}
                    open={immersionMenu}
                    PaperProps={{
                      style: { width: 'auto', marginTop: 50, marginLeft: isMobile ? 0 : 50, borderRadius: 12 }
                    }}
                  >
                    {['Sort Chronologically', 'Sort by Immersion'].map((option, index) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={option}
                        onClick={() => {
                          setImmersionSortText(option);
                          onImmersionSort(index);
                        }}
                      >
                        <p className={classes.sortBtn}>{option}</p>
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
                <Grid item xs={12} className={classes.itemSection}>
                  <Grid container spacing={2}>
                    {immersionSortIndex ? (
                      agendaByImmersion.map((item, index) => (
                        <Grid key={index} className={classes.agendaItem}>
                          <AgendaItem
                            isMobile={isMobile}
                            item={item}
                            immersion={getImmersion(item)}
                            safety={getSafety(item)}
                            type={'immersion'}
                            index={index}
                            overviewAgendas={overviewAgendaList}
                            openPopover={() => openPopover('immersion', item)}
                          />
                        </Grid>
                      ))
                    ) : (
                      overviewAgendaList.map((item, index) => (
                        <Grid key={index} className={classes.agendaItem}>
                          <AgendaItem
                            isMobile={isMobile}
                            item={item}
                            immersion={getImmersion(item)}
                            safety={getSafety(item)}
                            type={'immersion'}
                            index={index}
                            overviewAgendas={overviewAgendaList}
                            openPopover={() => openPopover('immersion', item)}
                          />
                        </Grid>
                      ))
                    )}
                  </Grid>
                </Grid>
                {openImmersion && (
                  <div className={classes.popover}>
                    <Box className={classes.header}>
                      <p className={classes.modalTitle}>
                        {selectedItem?.marker_title}
                      </p>
                      <IconButton aria-label="close" onClick={() => closePopover()} style={{ background: 'transparent' }}>
                        <img className={classes.modalCloseIcon} src={'/assets/icons/creatordashboard/project-modal-close.svg'} alt={'img'} />
                      </IconButton>
                    </Box>
                    <Divider />
                    <Box p={2} pt={0} boxShadow={2}>
                      <>
                        <div className={classes.row} >
                          <img className={classes.popperBadgeIcon} src={getImmersionBadgeIcon(selectedItem)} alt={'icon'} />
                          <p className={classes.name_index} style={{ color: getColor(getImmersion(selectedItem)['color_indicator']) }}>
                            {getImmersionOverallIndex(getImmersion(selectedItem))}
                          </p>
                          <p className={classes.label_index} style={{ color: getColor(getImmersion(selectedItem)['color_indicator']) }}>
                            {getImmersionContextIndex(getImmersion(selectedItem))}
                          </p>
                        </div>
                        <div className={classes.row} style={{ marginTop: getSafety(selectedItem)['overall_index'] < 2 ? -5 : -10 }}>
                          <img className={classes.popperBadgeIcon} src={getSafetyBadgeIcon(selectedItem)} alt={'icon'} />
                          <p className={classes.name_index} style={{
                            color: (getSafety(selectedItem)['overall_index'] < 2) ? getColor('gray') : getColor(getSafety(selectedItem)['color_indicator'])
                          }}>
                            {(getSafety(selectedItem)['overall_index'] < 2) ? '--' : getSafetyOverallIndex(getSafety(selectedItem))}
                          </p>
                          <p className={classes.label_index} style={{
                            color: (getSafety(selectedItem)['overall_index'] < 2) ? getColor('gray') : getColor(getSafety(selectedItem)['color_indicator'])
                          }}>
                            {getSafetyContextIndex(getSafety(selectedItem))}
                          </p>
                        </div>

                        {getSegment(getRuntime(selectedItem?.start_marker_at, selectedItem?.end_marker_at), 'runtime', 0)}
                        {getSegment(getEpochTime(selectedItem?.start_marker_at), 'start time', 1)}
                        {getSegment(getEpochTime(selectedItem?.end_marker_at), 'stop time', 2)}
                      </>
                    </Box>
                  </div>
                )}
              </div>
            </div>
          </div>
          {showSafety() && (
            <div data-description='safe section'>
              <p className={classes.typeDescription}>How <span className={classes.bold}>Safe</span> were your participants during agenda sections?</p>
              <div className={pdfLoading ? classes.pdfCardSection : classes.cardSection}>
                <div className={classes.content}>
                  <div className={classes.cardHeader}>
                    <div className={classes.headerPanel} onClick={handleSafeMenuOpen} ref={safeAnchorRef}>
                      <span className={classes.sortText}>{safeSortText}</span> &nbsp;
                      <img className={classes.sortIcon} src={`/assets/icons/overview/sort-icon.svg`} alt='Sort' />
                    </div>
                    <Menu
                      anchorEl={safeAnchorRef.current}
                      elevation={1}
                      onClose={handleSafeMenuClose}
                      open={safeMenu}
                      PaperProps={{
                        style: { width: 'auto', marginTop: 50, marginLeft: isMobile ? 0 : 50, borderRadius: 12 }
                      }}
                    >
                      {['Sort Chronologically', 'Sort by Safety'].map((option, index) => (
                        <MenuItem
                          className={classes.menuItem}
                          key={option}
                          onClick={() => {
                            setSafeSortText(option);
                            onSafeSort(index);
                          }}
                        >
                          <p className={classes.sortBtn}>{option}</p>
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                  <Grid item xs={12} className={classes.itemSection}>
                    <Grid container spacing={2}>
                      {safeSortIndex ? (
                        agendaBySafe.map((item, index) => (
                          <Grid key={`safe-${index}`} className={classes.agendaItem}>
                            <AgendaItem
                              isMobile={isMobile}
                              item={item}
                              immersion={getImmersion(item)}
                              safety={getSafety(item)}
                              type={'safety'}
                              index={index}
                              overviewAgendas={overviewAgendaList}
                              openPopover={() => openPopover('safety', item)}
                            />
                          </Grid>
                        ))
                      ) : (
                        overviewAgendaList.map((item, index) => (
                          <Grid key={`safe-${index}`} className={classes.agendaItem}>
                            <AgendaItem
                              isMobile={isMobile}
                              item={item}
                              immersion={getImmersion(item)}
                              safety={getSafety(item)}
                              type={'safety'}
                              index={index}
                              overviewAgendas={overviewAgendaList}
                              openPopover={() => openPopover('safety', item)}
                            />
                          </Grid>
                        ))
                      )}
                    </Grid>
                  </Grid>
                  {openSafety && (
                    <div className={classes.popover}>
                      <Box className={classes.header}>
                        <p className={classes.modalTitle}>
                          {selectedItem?.marker_title}
                        </p>
                        <IconButton aria-label="close" onClick={() => closePopover()} style={{ background: 'transparent' }}>
                          <img className={classes.modalCloseIcon} src={'/assets/icons/creatordashboard/project-modal-close.svg'} alt={'img'} />
                        </IconButton>
                      </Box>
                      <Divider />
                      <Box p={2} pt={0} boxShadow={2}>
                        <>
                          <div className={classes.row} >
                            <img className={classes.popperBadgeIcon} src={getImmersionBadgeIcon(selectedItem)} alt={'icon'} />
                            <p className={classes.name_index} style={{ color: getColor(getImmersion(selectedItem)['color_indicator']) }}>
                              {getImmersionOverallIndex(getImmersion(selectedItem))}
                            </p>
                            <p className={classes.label_index} style={{ color: getColor(getImmersion(selectedItem)['color_indicator']) }}>
                              {getImmersionContextIndex(getImmersion(selectedItem))}
                            </p>
                          </div>
                          <div className={classes.row} style={{ marginTop: getSafety(selectedItem)['overall_index'] < 2 ? -5 : -10 }}>
                            <img className={classes.popperBadgeIcon} src={getSafetyBadgeIcon(selectedItem)} alt={'icon'} />
                            <p className={classes.name_index} style={{
                              color: (getSafety(selectedItem)['overall_index'] < 2) ? getColor('gray') : getColor(getSafety(selectedItem)['color_indicator'])
                            }}>
                              {(getSafety(selectedItem)['overall_index'] < 2) ? '--' : getSafetyOverallIndex(getSafety(selectedItem))}
                            </p>
                            <p className={classes.label_index} style={{
                              color: (getSafety(selectedItem)['overall_index'] < 2) ? getColor('gray') : getColor(getSafety(selectedItem)['color_indicator'])
                            }}>
                              {getSafetyContextIndex(getSafety(selectedItem))}
                            </p>
                          </div>

                          {getSegment(getRuntime(selectedItem?.start_marker_at, selectedItem?.end_marker_at), 'runtime', 0)}
                          {getSegment(getEpochTime(selectedItem?.start_marker_at), 'start time', 1)}
                          {getSegment(getEpochTime(selectedItem?.end_marker_at), 'stop time', 2)}
                        </>
                      </Box>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      }

      <ImmersionModal
        open={showAgendaModal}
        title={'Add an Agenda'}
        size={'md'}
        description={`Adding and agenda can make it much easier to look at what may be driving high and low points of the experience.`}
        titleOK={'Save'}
        cancelDisable={true}
        onClose={() => {
          setIsLoadingAgenda(false);
          setShowAgendaModal(false)
        }
        }
        additional={<AddAgenda onChange={onChange} onRemoveIds={onRemoveIds} />}
        loading={isLoadingAgenda}
        onApply={() => {
          onSaveComments()
        }}
      />
    </div>
  )
};

export default Agenda;